import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=7294a2f2&scoped=true&"
import script from "./uploadImage.vue?vue&type=script&lang=ts&"
export * from "./uploadImage.vue?vue&type=script&lang=ts&"
import style0 from "./uploadImage.vue?vue&type=style&index=0&id=7294a2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294a2f2",
  null
  
)

component.options.__file = "uploadImage.vue"
export default component.exports